import { request } from '../utils/request';

export const getUserCV = (userCVId) =>
  request({
    url: `/user-cv/${userCVId}`,
    method: 'GET',
  });

export const createUserCV = (dataRequest) =>
  request({
    url: '/user-cv',
    method: 'POST',
    data: dataRequest,
  });

export const deleteUserCV = (userCVId) =>
  request({
    url: `/user-cv/${userCVId}`,
    method: 'DELETE',
  });

export const updateUserCV = (dataRequest) =>
  request({
    url: '/user-cv',
    method: 'PUT',
    data: dataRequest,
  });

export const updateUserResume = (dataRequest) =>
  request({
    url: '/user-cv/updateResume',
    method: 'PUT',
    data: dataRequest,
  });

export const getUserCVByUserId = (userId) =>
  request({
    url: `/user-cv/user/${userId}`,
    method: 'GET',
  });

export const updateContactStatus = (id, isEnableContact) =>
  request({
    url: `/user-cv/${id}/updateContactStatus`,
    method: 'PUT',
    params: {
      id: id,
      isEnableContact: isEnableContact
    }
  });

export const updateJobSearchStatus = (id, isEnableJobSearch) =>
  request({
    url: `/user-cv/${id}/updateJobSearchStatus`,
    method: 'PUT',
    params: {
      id: id,
      isEnableJobSearch: isEnableJobSearch
    }
  });

export const searchUserCV = ({career, workTime, jobField, locationWork, sortByField, page = 0, size = 10} = {}) =>
  request({
    url: `/user-cv/search`,
    method: 'GET',
    params: {
      career: career,
      workTime: workTime,
      jobField: jobField,
      locationWork: locationWork,
      sortByField: sortByField,
      page: page,
      size: size
    }
  });

export const updateViewCount = (id) =>
  request({
    url: '/user-cv/updateViewCount',
    method: 'PUT',
    params: {
      id: id
    },
  });

export const updateOpenContactCount = (id) =>
  request({
    url: '/user-cv/updateOpenContactCount',
    method: 'PUT',
    params: {
      id: id
    },
  });

export const searchCVAdmin = ({name, email, career, phone, profession, education, experience, certificate, jobSearchStatus, allowBrokerContact, page = 0, size = 10} = {}) =>
  request({
    url: `/user-cv/searchCVAdmin`,
    method: 'GET',
    params: {
      name: name,
      email: email,
      career: career,
      phone: phone,
      profession: profession,
      education: education,
      experience: experience,
      certificate: certificate,
      jobSearchStatus: jobSearchStatus,
      allowBrokerContact: allowBrokerContact,
      page: page,
      size: size
    }
  });

